/* Atelier-Interaktionen: Lichtkegel und sanfte Neigung auf Produktkarten (nur feine Zeiger, ohne reduzierte Bewegung). */
(() => {
  'use strict';
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let active = null, frame = 0, last = null;
  const reset = (card) => { if (!card) return; card.style.removeProperty('--j-tilt-x'); card.style.removeProperty('--j-tilt-y'); card.classList.remove('is-lit'); };
  const paint = () => {
    frame = 0;
    if (!active || !last) return;
    const r = active.getBoundingClientRect();
    const x = (last.clientX - r.left) / r.width, y = (last.clientY - r.top) / r.height;
    active.style.setProperty('--j-mx', (x * 100).toFixed(1) + '%');
    active.style.setProperty('--j-my', (y * 100).toFixed(1) + '%');
    active.style.setProperty('--j-tilt-x', ((0.5 - y) * 4).toFixed(2) + 'deg');
    active.style.setProperty('--j-tilt-y', ((x - 0.5) * 5).toFixed(2) + 'deg');
  };
  document.addEventListener('pointermove', (event) => {
    const card = event.target.closest && event.target.closest('.j-card');
    if (card !== active) { reset(active); active = card; if (card) card.classList.add('is-lit'); }
    if (!card) return;
    last = event;
    if (!frame) frame = requestAnimationFrame(paint);
  }, { passive: true });
  document.addEventListener('pointerleave', () => { reset(active); active = null; });
})();

/* Scroll-Geschichte „Vom Hof bis zu dir“: aktive Station steuert die Bühne (Desktop). */
(() => {
  'use strict';
  const story = document.querySelector('[data-story]');
  if (!story || !('IntersectionObserver' in window)) return;
  const steps = [...story.querySelectorAll('[data-story-step]')];
  const frames = [...story.querySelectorAll('[data-story-frame]')];
  const bar = story.querySelector('.j-story__progress span');
  const desktop = matchMedia('(min-width: 990px)');
  const set = (i) => {
    frames.forEach((f, k) => f.classList.toggle('is-active', k === i));
    steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
    if (bar) bar.style.transform = 'scaleY(' + ((i + 1) / steps.length) + ')';
  };
  const io = new IntersectionObserver((entries) => {
    if (!desktop.matches) return;
    entries.forEach((e) => { if (e.isIntersecting) set(steps.indexOf(e.target)); });
  }, { rootMargin: '-45% 0px -45% 0px' });
  steps.forEach((s) => io.observe(s));
  set(0);
})();

/* Scroll-Reveal: nur Elemente unterhalb des Sichtbereichs, Inhalte bleiben ohne JS sichtbar. */
(() => {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const sel = '#MainContent :is(h2, .j-card, .j-theke__item, .j-station, .j-pass, .j-locator, .j-atlas__plate, .j-frieze, .j-home-voices article, .j-journal__grid article, .j-final__inner, .j-chapter-mark)';
  const vh = innerHeight;
  const items = [...document.querySelectorAll(sel)].filter((el) => el.getBoundingClientRect().top > vh * 0.9 && !el.closest('.j-story, .j-atlas__panel, [hidden]') && !el.classList.contains('visually-hidden'));
  if (!items.length) return;
  const groups = new Map();
  items.forEach((el) => {
    const parent = el.parentElement;
    const index = (groups.get(parent) || 0);
    groups.set(parent, index + 1);
    el.style.setProperty('--j-reveal-delay', Math.min(index, 5) * 70 + 'ms');
    el.classList.add('j-reveal');
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  items.forEach((el) => io.observe(el));
})();

/* Nur einzelne Kennzahlen zählen hoch; Bereiche und Produktkennungen bleiben stabil. */
(() => {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const nums = [...document.querySelectorAll('#MainContent .j-voices-score__num, #MainContent .j-reference-proof strong, #MainContent .j-dial__big')];
  const run = (el) => {
    const text = el.textContent; const m = text.match(/^(\d+)(,(\d+))?(?=\s*[%+]?\s*$)/);
    if (!m) return;
    const dec = m[3] ? m[3].length : 0, target = parseFloat(m[1] + '.' + (m[3] || '0')), rest = text.slice(m[0].length);
    const start = performance.now(), dur = 1300;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur), v = target * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(dec).replace('.', ',') + rest;
      if (p < 1) requestAnimationFrame(tick); else el.textContent = text;
    };
    requestAnimationFrame(tick);
  };
  const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .6 });
  nums.filter((n) => n.children.length === 0 || n.classList.contains('j-voices-score__num')).forEach((n) => io.observe(n));
})();

/* Kopfzeile: Goldlinie und Lesefortschritt beim Scrollen. */
(() => {
  'use strict';
  const header = document.querySelector('sticky-header.header-wrapper');
  if (!header) return;
  const bar = document.createElement('span');
  bar.className = 'j-read-progress'; bar.setAttribute('aria-hidden', 'true');
  header.appendChild(bar);
  let frame = 0, max = 0, scrolled = null, scale = '';
  // Measure the page height only when it changes, not on every scroll frame.
  const measure = () => { max = document.documentElement.scrollHeight - innerHeight; };
  const update = () => {
    frame = 0;
    const isScrolled = scrollY > 40;
    if (isScrolled !== scrolled) { scrolled = isScrolled; document.documentElement.classList.toggle('j-scrolled', isScrolled); }
    const next = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0).toFixed(4) + ')';
    if (next !== scale) { scale = next; bar.style.transform = next; }
  };
  const request = () => { if (!frame) frame = requestAnimationFrame(update); };
  if ('ResizeObserver' in window) new ResizeObserver(() => { measure(); request(); }).observe(document.body);
  addEventListener('resize', () => { measure(); request(); });
  addEventListener('scroll', request, { passive: true });
  measure();
  update();
})();
